export default "__VITE_ASSET__940b86f2__"